(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/reducers/last-searched.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/reducers/last-searched.js');
"use strict";


const _RTK = RTK,
  createReducer = _RTK.createReducer;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const MAX_LAST_SEARCHED = svs.components.casino_react.common.constants.MAX_LAST_SEARCHED;
const _svs$components$casin = svs.components.casino_react.casinoStore.actions.lastSearched,
  addGameToLastSearched = _svs$components$casin.addGameToLastSearched,
  clearLastSearched = _svs$components$casin.clearLastSearched;
const lastSearched = svs.components.casino.data.lastSearched;
const reducerInitialState = lastSearched !== null && lastSearched !== void 0 ? lastSearched : [];
const lastSearchedReducer = createReducer(reducerInitialState, builder => {
  builder.addCase(addGameToLastSearched, (state, action) => {
    if (!isLoggedIn) {
      return state;
    }
    const gameIndex = state.indexOf(action.payload);
    if (gameIndex !== -1) {
      state.splice(gameIndex, 1);
    }
    state.unshift(action.payload);
    if (state.length > MAX_LAST_SEARCHED) {
      state.pop();
    }
    return state;
  }).addCase(clearLastSearched, state => {
    if (!isLoggedIn) {
      return state;
    }
    state = [];
    return state;
  });
});
setGlobal('svs.components.casino_react.casinoStore.reducers.lastSearchedReducer', lastSearchedReducer);

 })(window);